
import {
  Category,
  CertImportResult,
  Content,
  NodeItem,
} from "@/script/apps/cms/entity/CmsEntity";
import { ElMessage } from "element-plus";
import { Options, Vue } from "vue-class-component";

@Options({})
export default class CertResult extends Vue {
  private dialogVisible = false;
  private certResult: CertImportResult | undefined;

  public show(certResult: CertImportResult) {
    this.certResult = certResult;
    this.dialogVisible = true;
  }
}
